import rootAPIs from '@/api/rootAPIs';

const state = {
  products: [],
};

const mutations = {
  /* eslint-disable no-param-reassign */
  setProductList(productState, productData) {
    productState.products = productData;
  },
  /* eslint-enable no-param-reassign */
};

const actions = {
  /**
   * Fetches product data from the Rebate server using the application
   *
   * @param commit A function that allows sending mutations to the store
   * @param applicationId The id of the application
   */
  fetchProductData({ commit }, applicationId) {
    rootAPIs.getProductData(applicationId)
      .then((productData) => {
        commit('setProductList', productData);
      })
      .catch(() => {});
  },
};

const getters = {
  /**
   * Filters a single product by id from the products list
   * @param productState The current state object
   * @returns {function(*): T}
   */
  productById: productState => productId =>
    productState.products.find(item => item.id === productId),
  productByCategoryId: productState => categoryId =>
    productState.products.find(item => item.category_id === categoryId),
  productsLoaded: productState =>
    productState.products.length > 0,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
